<template>
  <div class="flex p-default gap-sm flex-col" :style="`width: ${customWidth}; height: ${customHeight};`">
    <div class="flex">
      <span>{{$t("webcam.placeholder")}}</span>
      <el-select @change="webcam.changeCamera($event);" v-model="currentDeviceId">
        <el-option v-for="(device, index) in devices" :label="device.label"
                   :value="device.deviceId" :key="index" />
      </el-select>
    </div>
    <div class="ari-flex">
      <Camera
        v-show="(!error && devices)"
        ref="webcam"
        @error="onError"
        @started="onStarted"
      />
    </div>
    <div class="flex flex-row justify-between">
      <label for="input-file__pictures" class="ari-flex ari-gap-default" style="margin-bottom: 0px;">
        <input type="file" class="hidden" ref="fileInput" accept="image/*" @change="handleUpload($event)"/>
        <AriButton
          rounded
          filled
          useCustomColor
          useCustomBgColor
          :content="$t('webcam.importPicture')"
          @click="triggerFileInput"
        />
      </label>
      <AriButton
      rounded
      filled
      useCustomColor
      useCustomBgColor
      :content="$t('webcam.takePicture')"
      @click="onCapture()"
    />
    </div>
    <p v-show="error" class="error ari-text-center">{{$t('webcam.error')}}</p>
  </div>
</template>
<script setup>
import Camera from "simple-vue-camera";
import { useTemplateRef, ref } from "vue";

const fileInput = ref(null);
const devices = ref([]);
const currentDeviceId = ref();
const error = ref();
const props = defineProps({
  customWidth: {
    type: String,
    default: '200px'
  },
  customHeight: {
    type: String,
    default: '200px'
  },
});
const webcam = useTemplateRef('webcam');
const emit = defineEmits(['imageCaptured']);

const triggerFileInput = () => {
  fileInput.value.click();
};

const handleUpload = async (event) => {
  if(event.target.files[0]) {
    const base64 = await blobToBase64(event.target.files[0]);
    const croppedBase64 = await cropBase64To200x200(base64);
    emit('imageCaptured', croppedBase64);
    return base64;
  }
};

const onStarted = async () => {
  const arrInputDeviceInfo = await webcam.value.devices(["videoinput"]);
  if (devices.value.length === 0) {
    devices.value = arrInputDeviceInfo.filter(device => device.deviceId).map((device) => {
      return {label: device.label, deviceId: device.deviceId};
    });
    if (devices.value.length) {
      const tmpDeviceId = devices.value[0].deviceId;
      currentDeviceId.value = tmpDeviceId;
    }
  }
};

const onError = function () {
  error.value = true;
};

const onCapture = async function () {
  const blob = await webcam.value.snapshot({ width: 1920, height: 1080 }, "image/jpeg", 0.9);
  const base64 = await blobToBase64(blob);
  const croppedBase64 = await cropBase64To200x200(base64);
  emit('imageCaptured', croppedBase64);
  return base64;
};

const blobToBase64 = async function (blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

function cropBase64To200x200(base64, cropX = 0, cropY = 0) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 200;
      canvas.height = 200;

      const size = Math.min(img.width, img.height);
      const sx = (img.width - size) / 2;
      const sy = (img.height - size) / 2;

      ctx.drawImage(
        img,
        sx,
        sy,
        size,
        size,
        0,
        0,
        200,
        200
      );

      const croppedBase64 = canvas.toDataURL("image/jpeg", 0.9);
      resolve(croppedBase64);
    };
  });
}

</script>

<style scoped>
.error {
  color: red;
}
</style>
